import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Heart } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_shine-beauty/artifacts/9gn465w9_Buttershine%20logo%20no%20bg.png";

const footerLinks = {
  company: [
    { name: 'Products', href: '#products' },
    { name: 'Our Story', href: '#story' },
    { name: 'Contact Us', href: '#contact' },
    { name: 'Request Quotation', href: '#contact' },
  ],
};

export const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer data-testid="footer" className="bg-[#2C2C2C] text-white pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-16">
          {/* Brand Column */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-1"
          >
            <img
              src={LOGO_URL}
              alt="Buttershine"
              className="h-12 mb-6"
              data-testid="footer-logo"
            />
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Premium beauty and wellness tools curated for everyone. 
              Self-care is a lifestyle, not a luxury.
            </p>
            <p className="text-[#DAB668] text-sm font-medium">
              Founded by Varun Mohan
            </p>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4 className="font-serif text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-white/70 text-sm hover:text-[#DAB668] transition-colors"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <h4 className="font-serif text-lg mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3" data-testid="footer-email">
                <Mail className="w-4 h-4 text-[#DAB668] mt-1 flex-shrink-0" />
                <a href="mailto:shop@buttershine.com" className="text-white/70 text-sm hover:text-[#DAB668] transition-colors">
                  shop@buttershine.com
                </a>
              </li>
              <li className="flex items-start gap-3" data-testid="footer-phone">
                <Phone className="w-4 h-4 text-[#DAB668] mt-1 flex-shrink-0" />
                <a href="tel:+919945699525" className="text-white/70 text-sm hover:text-[#DAB668] transition-colors">
                  +91 99456 99525
                </a>
              </li>
              <li className="flex items-start gap-3" data-testid="footer-address">
                <MapPin className="w-4 h-4 text-[#DAB668] mt-1 flex-shrink-0" />
                <span className="text-white/70 text-sm">
                  Building Veena, Bajal Road,<br />
                  Mangaluru, Karnataka - 575009
                </span>
              </li>
            </ul>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4"
        >
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Buttershine. All rights reserved.
          </p>
          <p className="text-white/50 text-sm flex items-center gap-1">
            Made with <span className="text-red-500">❤️</span> 
            <a 
              href="https://www.autom8.digital" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#DAB668] hover:text-white transition-colors ml-1"
              data-testid="autom8-link"
            >
              Autom8
            </a>
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
